export const CPBL_TEAMS = [
  'CTBC Brothers',
  'Fubon Guardians',
  'Rakuten Monkeys',
  'TSG Hawks',
  'Uni-President 7-Eleven Lions',
  'Wei Chuan Dragons',
];
